module.exports = __webpack_public_path__ + "public/files/img/wp-type-1.d9de47e9.png";